import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { ORG_LABELS, TEAM_LABELS } from '../config';
import { Badge, Segmented, Tabs } from '../ui/basics';
import Attrition from './analytics/Attrition';
import Bench from './analytics/Bench';
import Billing from './analytics/Billing';
import DataHealth from './analytics/DataHealth';
import Headcount from './analytics/Headcount';
import MarginRisk from './analytics/MarginRisk';
import MarginTrend from './analytics/MarginTrend';
import OnboardingPipeline from './analytics/OnboardingPipeline';
import Retention from './analytics/Retention';
import Scorecards from './analytics/Scorecards';
import Watchlist from './analytics/Watchlist';

const TABS = [
  { key: 'watchlist', label: 'Watchlist', Component: Watchlist },
  { key: 'attrition', label: 'Early attrition', Component: Attrition },
  { key: 'retention', label: 'Retention & forecast', Component: Retention },
  { key: 'headcount', label: 'Headcount flow', Component: Headcount },
  { key: 'margin', label: 'Margin trend', Component: MarginTrend },
  { key: 'risk', label: 'Margin risk', Component: MarginRisk },
  { key: 'scorecards', label: 'Scorecards', Component: Scorecards },
  { key: 'bench', label: 'Bench', Component: Bench },
  { key: 'onboarding', label: 'Onboarding', Component: OnboardingPipeline, needs: (a) => a.hasPage('onboardings') },
  { key: 'billing', label: 'Billing', Component: Billing, needs: (a) => a.allTeams },
  { key: 'health', label: 'Data health', Component: DataHealth },
];

export default function Analytics() {
  const auth = useAuth();
  const { org, teams, allTeams } = auth;
  const tabs = TABS.filter((t) => !t.needs || t.needs(auth));
  const [tab, setTab] = useState('watchlist');
  const [lead, setLead] = useState('');
  // Users limited to some teams can only pick among those; '' means "all of my teams".
  const options = [
    ...(allTeams || teams.length > 1 ? [{ value: '', label: allTeams ? 'All teams' : 'All my teams' }] : []),
    ...(allTeams ? Object.keys(TEAM_LABELS) : teams).map((t) => ({ value: t, label: TEAM_LABELS[t] })),
  ];
  const fixedLead = !allTeams && teams.length === 1 ? teams[0] : '';
  useEffect(() => setLead(''), [org]);
  const { Component } = (tabs.find((t) => t.key === tab) || tabs[0]);
  const effectiveLead = fixedLead || lead;

  return (
    <div className="stack">
      <div className="page-head">
        <div><h1>Analytics</h1><p>{ORG_LABELS[org]} · what needs attention, and how placements are trending</p></div>
        <div className="actions">
          {fixedLead ? <Badge tone="accent">{TEAM_LABELS[fixedLead]} team</Badge>
            : options.length > 1 && <Segmented options={options} value={lead} onChange={setLead} />}
        </div>
      </div>
      <Tabs tabs={tabs} value={tab} onChange={setTab} />
      <Component key={`${org}-${effectiveLead}`} org={org} lead={effectiveLead} />
    </div>
  );
}
